import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type CashOutProps = {
  index: number
}

export const CashOut = ({ index }: CashOutProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.cashOut`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Cash Out" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
